import {
    MODULEMASTERLISTFORADMIN_SUCCESS,
    MODULEMASTERLISTFORADMIN_FAILED,
    RESET_MODULEMASTERLISTFORADMIN,
    LOADING_MODULEMASTERLISTFORADMIN,
    NETWORK_ERROR_MODULEMASTERLISTFORADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_MODULEMASTERLISTFORADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case MODULEMASTERLISTFORADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case MODULEMASTERLISTFORADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_MODULEMASTERLISTFORADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_MODULEMASTERLISTFORADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
